import { render, staticRenderFns } from "./FormiumFormBuilder.vue?vue&type=template&id=2f6b9dde"
import script from "./FormiumFormBuilder.vue?vue&type=script&lang=js"
export * from "./FormiumFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./FormiumFormBuilder.vue?vue&type=style&index=0&id=2f6b9dde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports